function isNumber(num: any): num is number {
  return typeof num === 'number';
}

export default isNumber;
